export enum AppFeature {
  CONSOLE = "solutions/console",
  QUERYAPI = "solutions/query-api",
  DATA_DELIVERY = "solutions/data-delivery-feed",
  BULK_DATA_DELIVERY = "solutions/bulk-data-delivery",
  CUSTOM_LOCATIONS = "solutions/custom-locations-api",
  INSIGHTS_APP = "solutions/insights-app",
  BOUNDARIES = "solutions/boundaries",
  // Opts an account into candidate dataset versions (served in place of the
  // current ones, see unacat product_listing/candidate.go). Not a Console
  // feature as such: used to target release announcements.
  CANDIDATE_ACCESS = "solutions/candidate-access",
}
